export { default } from './parts-diagram';
